module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-BlackItalic.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-BlackItalic.woff
// module id = 60
// module chunks = 8